webpackJsonp([2],{

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(98),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);



//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'checkout',
  props: {
    cart: {
      type: Object,
      // Object or array defaults must be returned from
      // a factory function
      default: function _default() {
        return {
          intent: '',
          payer: null,
          items: []
        };
      }
    },
    buttonUniqueReference: {
      type: String,
      required: true
    }
  },
  data: function data() {
    var defaultPurchaseUnit = {
      reference_id: null,
      description: "lorem",
      amount: {
        currency_code: "USD",
        value: 100
      }
    };

    return {
      order: {
        intent: 'CAPTURE',
        payer: {},
        purchase_units: [__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, defaultPurchaseUnit)]
      }
    };
  },

  mounted: function mounted() {
    this.order.intent = this.cart.intent;
    this.order.purchase_units = this.cart.items;

    if (this.cart.payer) {
      this.order.payer = this.cart.payer;
    }

    this.setLoaded();
  },
  computed: {
    // This is important to enable displaying multiple (a group of) smart buttons in a single page
    // by assigning each with unique identifier, we can refer it and render each dnyamically
    dynamicSelectorContainer: function dynamicSelectorContainer() {
      return '#' + this.buttonUniqueReference;
    }
  },
  methods: {
    setLoaded: function setLoaded() {
      var _this = this;

      window.paypal.Buttons({
        createOrder: function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(data, actions) {
            var paypalOrderId;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return actions.order.create(_this.order);

                  case 2:
                    paypalOrderId = _context.sent;


                    _this.$emit('paypal-order-created', paypalOrderId);

                    // HAS to return the ID for the checkout process to run smoothly
                    return _context.abrupt('return', paypalOrderId);

                  case 5:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this);
          }));

          return function createOrder(_x, _x2) {
            return _ref.apply(this, arguments);
          };
        }(),
        onApprove: function () {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(data, actions) {
            var order;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return actions.order.capture();

                  case 2:
                    order = _context2.sent;
                    return _context2.abrupt('return', _this.$emit('paypal-order-approved', order));

                  case 4:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, _this);
          }));

          return function onApprove(_x3, _x4) {
            return _ref2.apply(this, arguments);
          };
        }(),
        onError: function onError(err) {
          _this.$emit('paypal-order-failed', err);
        }
      }).render(this.dynamicSelectorContainer);
    }
  }
});

/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_checkout__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_checkout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_checkout__);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__components_checkout___default.a);

/***/ }),

/***/ 98:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paypal-smart-payment-buttons-checkout"
  }, [_c('div', {
    attrs: {
      "id": _vm.buttonUniqueReference
    }
  })])
},staticRenderFns: []}

/***/ })

},[50]);


// WEBPACK FOOTER //
// docs/js/vue-paypal-smart-payment-buttons.941a319ceb70af355933.js